export default __webpack_public_path__ + "static/media/brand_varram.2ef30142.png";